package com.iregained.site.components.sections.contact.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val ContactSupportContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(Colors.White)
}

val ContactSupportGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1200.px).gap(32.px)
}

val SupportCardStyle = CssStyle.base {
    Modifier.fillMaxWidth().height(100.percent).padding(40.px).borderRadius(16.px)
        .border(1.px, LineStyle.Solid, colorMode.toSitePalette().custom.lightGray).backgroundColor(Colors.White)
}

val SupportIconWrapperStyle = CssStyle.base {
    Modifier.size(56.px).borderRadius(12.px)
        .backgroundColor(colorMode.toSitePalette().brand.primary.toRgb().copyf(alpha = 0.1f)) // Faded Teal Background
        .display(DisplayStyle.Flex).justifyContent(JustifyContent.Center).alignItems(AlignItems.Center)
        .margin(bottom = 24.px)
}

val SupportIconStyle = CssStyle.base {
    Modifier.size(36.px)
}

val SupportCardTitleStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText).fontSize(1.25.cssRem).fontWeight(FontWeight.Bold)
        .margin(bottom = 12.px)
}

val SupportCardDescStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText.toRgb().copyf(alpha = 0.8f)).fontSize(1.cssRem)
        .lineHeight(1.6).margin(bottom = 24.px)
}

val SupportLinkContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().display(DisplayStyle.Flex).flexDirection(FlexDirection.Column).gap(12.px)
}

val SupportLinkItemStyle = CssStyle {
    base {
        Modifier.color(colorMode.toSitePalette().brand.primary).fontSize(1.cssRem).fontWeight(FontWeight.SemiBold)
            .textDecorationLine(TextDecorationLine.None)
            .transition(com.varabyte.kobweb.compose.css.Transition.of("opacity", 200.ms))
    }
    hover {
        Modifier.opacity(70.percent)
    }
}